import { IconPropsType } from '../../types'
import { IconRepository } from '../icons/icon.repository'

export enum DashboardType {
  ADMIN = 0,
  INITIATOR = 1,
  VALIDATOR = 2,
  SUPER_ADMIN = 3,
  USER = 4,
}

export type DataLinksType = {
  link: string
  label: string
  icon: ({ width, height, color }: IconPropsType) => JSX.Element
  ref?: DashboardType[]
}

export const upperSidebarLinks: DataLinksType[] = [
  {
    link: '/dashboard',
    label: 'Dashboard',
    icon: IconRepository.OverviewIcon,
    ref: [DashboardType.ADMIN, DashboardType.INITIATOR, DashboardType.VALIDATOR, DashboardType.USER],
  },
  {
    link: '/dashboard/transactions',
    label: 'Transactions',
    icon: IconRepository.AdminTransactionIcon,
    ref: [DashboardType.ADMIN, DashboardType.INITIATOR, DashboardType.VALIDATOR, DashboardType.USER],
  },
  {
    link: '/dashboard/schedules',
    label: 'Schedules',
    icon: IconRepository.CalendarIcon,
    ref: [DashboardType.ADMIN, DashboardType.INITIATOR, DashboardType.VALIDATOR, DashboardType.USER],
  },
]

export const UpperSidebarAdminLinks: DataLinksType[] = [
  ...upperSidebarLinks,
  {
    link: '/dashboard/beneficiaries',
    label: 'Beneficiaries',
    icon: IconRepository.BeneficiariesIcon,
    ref: [DashboardType.ADMIN],
  },
  {
    link: '/dashboard/contacts',
    label: 'Contacts',
    icon: IconRepository.UsersOutlineIcon,
    ref: [DashboardType.ADMIN],
  },
  // {
  //   link: '/dashboard/users',
  //   label: 'Users',
  //   icon: IconRepository.UsersIcon,
  //   ref: [DashboardType.ADMIN],
  // },
]

export const UpperSidebarValidatorLinks: DataLinksType[] = [...upperSidebarLinks]

export const UpperSidebarInitiatorLinks: DataLinksType[] = [
  ...upperSidebarLinks,
  {
    link: '/dashboard/beneficiaries',
    label: 'Beneficiaries',
    icon: IconRepository.BeneficiariesIcon,
    ref: [DashboardType.INITIATOR],
  },
  {
    link: '/dashboard/contacts',
    label: 'Contacts',
    icon: IconRepository.UsersOutlineIcon,
    ref: [DashboardType.INITIATOR],
  },
]

export const UpperSidebarUserLinks: DataLinksType[] = [
  ...upperSidebarLinks,
  {
    link: '/dashboard/contacts',
    label: 'Contacts',
    icon: IconRepository.UsersOutlineIcon,
    ref: [DashboardType.USER],
  },
]

export const UpperSidebarSuperAdminLinks: DataLinksType[] = [
  ...UpperSidebarAdminLinks,
  {
    link: '/dashboard/admin/kyc-management',
    label: 'KYC Management',
    icon: IconRepository.BeneficiariesIcon,
    ref: [DashboardType.SUPER_ADMIN],
  },
]

export const LowerSidebarLinks = [
  {
    link: '/dashboard/settings',
    label: 'Settings',
    icon: IconRepository.SettingsIcon,
    ref: [
      DashboardType.ADMIN,
      DashboardType.INITIATOR,
      DashboardType.SUPER_ADMIN,
      DashboardType.VALIDATOR,
      DashboardType.USER,
    ],
  },
  {
    link: 'login',
    label: 'Logout',
    icon: IconRepository.LogoutIcon,
    ref: [
      DashboardType.ADMIN,
      DashboardType.INITIATOR,
      DashboardType.SUPER_ADMIN,
      DashboardType.VALIDATOR,
      DashboardType.USER,
    ],
  },
]

export const UpperSidebarOrganizationLinks: DataLinksType[] = [
  {
    link: '/dashboard/organization',
    label: 'Dashboard',
    icon: IconRepository.OverviewIcon,
  },
  {
    link: '/dashboard/organization/api-keys',
    label: 'API Keys',
    icon: IconRepository.AdminTransactionIcon,
  },
  {
    link: '/dashboard/organization/transactions',
    label: 'Transactions',
    icon: IconRepository.CalendarIcon,
  },
  {
    link: '/dashboard/organization/bank-transfer',
    label: 'Bank Transfer Top-Up',
    icon: IconRepository.BuildingIcon,
  },
  {
    link: '/dashboard/organization/card-payment',
    label: 'Card Top-Up',
    icon: IconRepository.AdminTransactionIcon,
  },
  {
    link: '/dashboard/organization/single-payment',
    label: 'Single Payment',
    icon: IconRepository.BeneficiariesIcon,
  },
  {
    link: '/dashboard/organization/bulk-payment',
    label: 'Bulk Payment',
    icon: IconRepository.UsersOutlineIcon,
  },
  {
    link: '/dashboard/organization/payouts',
    label: 'Payouts',
    icon: IconRepository.BeneficiariesIcon,
  },
  {
    link: '/dashboard/organization/webhooks',
    label: 'Webhooks',
    icon: IconRepository.BeneficiariesIcon,
  },
  {
    link: '/dashboard/organization/kyc',
    label: 'KYC Verification',
    icon: IconRepository.UsersOutlineIcon,
  },
]

export const LowerSidebarOrganizationLinks = [
  {
    link: '/dashboard/organization/settings',
    label: 'Settings',
    icon: IconRepository.SettingsIcon,
  },
  {
    link: 'login',
    label: 'Logout',
    icon: IconRepository.LogoutIcon,
  },
]
